import React from 'react';
import { Users, Calendar, DollarSign, TrendingUp, Clock, CheckCircle, AlertCircle, FileText } from 'lucide-react';
import './OverviewCard.css';

const OverviewCard = () => {
  const stats = [
    {
      title: 'Total Patients',
      value: '1,247',
      change: '+12%',
      icon: <Users size={24} />,
      color: '#DAA520'
    },
    {
      title: 'Appointments Today',
      value: '18',
      change: '+3',
      icon: <Calendar size={24} />,
      color: '#28a745'
    },
    {
      title: 'Revenue This Month',
      value: '$45,230',
      change: '+8.5%',
      icon: <DollarSign size={24} />,
      color: '#17a2b8'
    },
    {
      title: 'Pending Tasks',
      value: '7',
      change: '-2',
      icon: <Clock size={24} />,
      color: '#ffc107'
    }
  ];

  const recentActivities = [
    {
      type: 'appointment',
      title: 'New appointment scheduled',
      description: 'Dr. Sarah Johnson - Annual Checkup',
      time: '2 minutes ago',
      status: 'confirmed'
    },
    {
      type: 'message',
      title: 'New message received',
      description: 'From Dr. Michael Davis',
      time: '15 minutes ago',
      status: 'unread'
    },
    {
      type: 'document',
      title: 'Document uploaded',
      description: 'Blood Test Results - Dec 2024',
      time: '1 hour ago',
      status: 'completed'
    },
    {
      type: 'payment',
      title: 'Payment received',
      description: 'Invoice #INV-001 - $350.00',
      time: '2 hours ago',
      status: 'completed'
    }
  ];

  const upcomingAppointments = [
    {
      patient: 'John Smith',
      service: 'Annual Checkup',
      time: 'Today at 2:30 PM',
      status: 'Confirmed'
    },
    {
      patient: 'Sarah Johnson',
      service: 'Follow-up Consultation',
      time: 'Tomorrow at 10:00 AM',
      status: 'Confirmed'
    },
    {
      patient: 'Michael Davis',
      service: 'Physical Therapy',
      time: 'Friday at 3:45 PM',
      status: 'Pending'
    }
  ];

  const getActivityIcon = (type) => {
    switch (type) {
      case 'appointment':
        return <Calendar size={16} />;
      case 'message':
        return <FileText size={16} />;
      case 'document':
        return <FileText size={16} />;
      case 'payment':
        return <DollarSign size={16} />;
      default:
        return <CheckCircle size={16} />;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'confirmed':
      case 'completed':
        return '#28a745';
      case 'pending':
        return '#ffc107';
      case 'unread':
        return '#17a2b8';
      default:
        return '#6c757d';
    }
  };

  return (
    <div className="overview-container">
      {/* Stats Grid */}
      <div className="stats-grid">
        {stats.map((stat, index) => (
          <div key={index} className="stat-card">
            <div className="stat-icon" style={{ color: stat.color }}>
              {stat.icon}
            </div>
            <div className="stat-content">
              <h3>{stat.value}</h3>
              <p>{stat.title}</p>
              <span className="stat-change" style={{ color: stat.color }}>
                {stat.change}
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Main Content Grid */}
      <div className="overview-content">
        {/* Recent Activities */}
        <div className="overview-section">
          <div className="section-header">
            <h2>Recent Activities</h2>
            <button className="btn btn-outline">View All</button>
          </div>
          <div className="activities-list">
            {recentActivities.map((activity, index) => (
              <div key={index} className="activity-item">
                <div className="activity-icon" style={{ color: getStatusColor(activity.status) }}>
                  {getActivityIcon(activity.type)}
                </div>
                <div className="activity-content">
                  <h4>{activity.title}</h4>
                  <p>{activity.description}</p>
                  <span className="activity-time">{activity.time}</span>
                </div>
                <div className="activity-status">
                  <div 
                    className="status-dot" 
                    style={{ backgroundColor: getStatusColor(activity.status) }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Upcoming Appointments */}
        <div className="overview-section">
          <div className="section-header">
            <h2>Upcoming Appointments</h2>
            <button className="btn btn-outline">View Calendar</button>
          </div>
          <div className="appointments-list">
            {upcomingAppointments.map((appointment, index) => (
              <div key={index} className="appointment-item">
                <div className="appointment-info">
                  <h4>{appointment.patient}</h4>
                  <p>{appointment.service}</p>
                  <span className="appointment-time">{appointment.time}</span>
                </div>
                <div className="appointment-status">
                  <span 
                    className={`status-badge status-${appointment.status.toLowerCase()}`}
                  >
                    {appointment.status}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewCard;
